<template>
  <footer class="footer">
    <div class="footer-container">
      
      <div class="footer-col seo-col">
        <p class="indexacao-p">
          O <strong>Quadra Play SV</strong> é uma plataforma de agendamento de quadras em São Vicente.
          Também pesquisado como <strong>quadraplaysv</strong> ou <strong>quadra play</strong>,
          o sistema permite reservar quadras esportivas e acompanhar campeonatos locais.
        </p>
        <p class="indexacao-p">
          Se você busca <strong>alugar quadra em São Vicente</strong>, ou
          <strong>agendar quadra online</strong>, o Quadra Play SV facilita tudo em poucos cliques.
        </p>
      </div>

      <div class="footer-col branding">
        <h3>Redes Sociais</h3>

        <div class="social-icons">
          <a href="https://instagram.com/quadraplayofc" target="_blank" rel="noopener noreferrer"
            aria-label="Instagram">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-instagram"
              viewBox="0 0 16 16">
              <path
                d="M8 0C5.829 0 5.556.01 4.703.048 3.85.088 3.269.222 2.76.42a3.9 3.9 0 0 0-1.417.923A3.9 3.9 0 0 0 .42 2.76C.222 3.268.087 3.85.048 4.7.01 5.555 0 5.827 0 8.001c0 2.172.01 2.444.048 3.297.04.852.174 1.433.372 1.942.205.526.478.972.923 1.417.444.445.89.719 1.416.923.51.198 1.09.333 1.942.372C5.555 15.99 5.827 16 8 16s2.444-.01 3.298-.048c.851-.04 1.434-.174 1.943-.372a3.9 3.9 0 0 0 1.416-.923c.445-.445.718-.891.923-1.417.197-.509.332-1.09.372-1.942C15.99 10.445 16 10.173 16 8s-.01-2.445-.048-3.299c-.04-.851-.175-1.433-.372-1.941a3.9 3.9 0 0 0-.923-1.417A3.9 3.9 0 0 0 13.24.42c-.51-.198-1.092-.333-1.943-.372C10.443.01 10.172 0 7.998 0zm-.717 1.442h.718c2.136 0 2.389.007 3.232.046.78.035 1.204.166 1.486.275.373.145.64.319.92.599s.453.546.598.92c.11.281.24.705.275 1.485.039.843.047 1.096.047 3.231s-.008 2.389-.047 3.232c-.035.78-.166 1.203-.275 1.485a2.5 2.5 0 0 1-.599.919c-.28.28-.546.453-.92.598-.28.11-.704.24-1.485.276-.843.038-1.096.047-3.232.047s-2.39-.009-3.233-.047c-.78-.036-1.203-.166-1.485-.276a2.5 2.5 0 0 1-.92-.598 2.5 2.5 0 0 1-.6-.92c-.109-.281-.24-.705-.275-1.485-.038-.843-.046-1.096-.046-3.233s.008-2.388.046-3.231c.036-.78.166-1.204.276-1.486.145-.373.319-.64.599-.92s.546-.453.92-.598c.282-.11.705-.24 1.485-.276.738-.034 1.024-.044 2.515-.045zm4.988 1.328a.96.96 0 1 0 0 1.92.96.96 0 0 0 0-1.92m-4.27 1.122a4.109 4.109 0 1 0 0 8.217 4.109 4.109 0 0 0 0-8.217m0 1.441a2.667 2.667 0 1 1 0 5.334 2.667 2.667 0 0 1 0-5.334" />
            </svg>
          </a>
          <a href="https://www.youtube.com/@QuadraPlaySV" target="_blank" rel="noopener noreferrer"
            aria-label="Canal no YouTube">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-youtube"
              viewBox="0 0 16 16">
              <path
                d="M8.051 1.999h.089c.822.003 4.987.033 6.11.335a2.01 2.01 0 0 1 1.415 1.42c.101.38.172.883.22 1.402l.01.104.022.26.008.104c.065.914.073 1.77.074 1.957v.075c-.001.194-.01 1.108-.082 2.06l-.008.105-.009.104c-.05.572-.124 1.14-.235 1.558a2.01 2.01 0 0 1-1.415 1.42c-1.16.312-5.569.334-6.18.335h-.142c-.309 0-1.587-.006-2.927-.052l-.17-.006-.087-.004-.171-.007-.171-.007c-1.11-.049-2.167-.128-2.654-.26a2.01 2.01 0 0 1-1.415-1.419c-.111-.417-.185-.986-.235-1.558L.09 9.82l-.008-.104A31 31 0 0 1 0 7.68v-.123c.002-.215.01-.958.064-1.778l.007-.103.003-.052.008-.104.022-.26.01-.104c.048-.519.119-1.023.22-1.402a2.01 2.01 0 0 1 1.415-1.42c.487-.13 1.544-.21 2.654-.26l.17-.007.172-.006.086-.003.171-.007A100 100 0 0 1 7.858 2zM6.4 5.209v4.818l4.157-2.408z" />
            </svg>
          </a>
        </div>
      </div>

      <div class="footer-col">
        <h3>Navegação</h3>
        <ul>
          <li>
            <RouterLink to="/visualizarplacarhome" class="footer-link">
              Tabelas de Classificação
            </RouterLink>
          </li>
          <li>
            <RouterLink to="/times" class="footer-link">
              Times
            </RouterLink>
          </li>
          <li>
            <RouterLink to="/horarios-publico" class="footer-link">
              Horarios
            </RouterLink>
          </li>
        </ul>
      </div>

      <div class="footer-col">
        <h3>Suporte</h3>
        <ul class="suporte-list">
          <li class="suporte-item">
            <span class="footer-link email-link" @click="abrirGmail">
              quadraplaysv@gmail.com
            </span>
          </li>
        </ul>
      </div>

      <div class="footer-col">
        <h3>Parceiros</h3>
        <a href="https://saovicente.rn.gov.br" target="_blank" rel="noopener noreferrer" aria-label="Site do parceiro">
          <img src="@/assets/Captura de tela 2026-01-31 114733.png" alt="Logo do parceiro" class="parceiro-img" />
        </a>
      </div>
    </div>

    <div class="footer-bottom">
      <div class="copyright">
        © {{ year }} Quadra Play - Todos os direitos reservados.
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "FooterHome",

  data() {
    return {
      year: new Date().getFullYear()
    }
  },

  methods: {
    abrirGmail() {
      const email = 'quadraplaysv@gmail.com'
      window.open(
        `https://mail.google.com/mail/?view=cm&fs=1&to=${email}`,
        '_blank'
      )
    }
  }
}
</script>

<style scoped>
.footer {
  background: #152147;
  color: #fff;
  padding: 60px 80px 30px;
  position: relative;
  overflow: hidden;
}

.footer::before {
  content: "";
  position: absolute;
  inset: 0;
  background: radial-gradient(900px 260px at 20% 0%,
      rgba(59, 130, 246, 0.18),
      transparent 60%);
  pointer-events: none;
}

.footer-container {
  position: relative;
  display: grid;
  grid-template-columns: 1.5fr 1fr 1fr 1fr 1fr;
  gap: 40px;
  align-items: start;
}

.footer-col {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
}

.footer-col h3 {
  font-size: 18px;
  margin-bottom: 14px;
  font-weight: 800;
  letter-spacing: 0.2px;
}

.footer-col ul {
  list-style: none;
  padding: 0;
  margin: 0;
  width: 100%;
}

.footer-col ul li {
  font-size: 14px;
  color: rgba(209, 213, 219, 0.9);
  margin-bottom: 10px;
  cursor: pointer;
  transition: color 0.18s ease, transform 0.18s ease;
}

.footer-col ul li:hover {
  color: #3b82f6;
  transform: translateX(2px);
}

.seo-col {
  font-size: 11px;
  line-height: 1.5;
  color: rgba(209, 213, 219, 0.5);
}

.seo-col p {
  margin-bottom: 8px;
}

.seo-col p:last-child {
  margin-bottom: 0;
}

.social-icons {
  display: flex;
  justify-content: flex-start;
  gap: 14px;
  margin-top: 12px;
  width: 100%;
}

.social-icons svg {
  cursor: pointer;
  color: rgba(209, 213, 219, 0.9);
  width: 22px;
  height: 22px;
  transition: color 0.18s ease, transform 0.18s ease, opacity 0.18s ease;
  opacity: 0.92;
}

.social-icons svg:hover {
  color: #3b82f6;
  transform: translateY(-2px);
  opacity: 1;
}

.suporte-list {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
}

.suporte-item {
  display: flex;
  align-items: center;
  gap: 8px;
  color: rgba(209, 213, 219, 0.95);
}

.parceiro-img {
  width: 100%;
  max-width: 220px;
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.12);
  padding: 12px 14px;
  border-radius: 12px;
  box-sizing: border-box;
}

.footer-bottom {
  margin-top: 40px;
  padding-top: 20px;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.copyright {
  font-size: 14px;
  color: rgba(209, 213, 219, 0.9);
}

.footer-link {
  color: rgba(209, 213, 219, 0.9);
  text-decoration: none;
  font-size: 14px;
  transition: color 0.18s ease;
}

.footer-link:hover {
  color: #3b82f6;
}

.indexacao-p {
  text-align: justify;
}

@media (max-width: 768px) {
  .footer {
    padding: 40px 20px 40px;
  }

  .footer-container {
    display: flex;
    flex-direction: column;
    gap: 40px;
  }

  .footer-col {
    align-items: center;
    text-align: center;
    width: 100%;
  }

  .footer-col ul li {
    text-align: center;
  }

  .indexacao-p {
    text-align: justify;
  }

  .seo-col {
    order: 5;
    border-top: 1px solid rgba(255, 255, 255, 0.08);
    padding-top: 20px;
    margin-top: 10px;
  }

  .social-icons {
    justify-content: center;
  }

  .suporte-list {
    align-items: center;
  }
  
  .suporte-item {
    justify-content: center;
  }

  .parceiro-img {
    margin: 0 auto;
    max-width: 240px;
  }
}
</style>
